import { Create, SimpleForm, useGetIdentity } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';
import { OrganizationFormFields } from './OrganizationForm';

export const OrganizationCreate = () => {
  const { identity } = useGetIdentity();

  // Non-admin creators own the organization themselves
  const transform = (data: Record<string, any>) => ({
    ...data,
    client_id: data.client_id ?? identity?.id,
  });

  return (
    <Create redirect="list" transform={transform}>
      <SimpleForm toolbar={<MyToolbar resource="organizations" />}>
        <MyFormContainer>
          <OrganizationFormFields isCreate />
        </MyFormContainer>
      </SimpleForm>
    </Create>
  );
};

export default OrganizationCreate;
